export default function notificationsSummaryReducer(state = [], action) {
   const { type, notificationsSummaryData } = action
   switch (type) {
      case 'SET_NOTIFICATIONS_SUMMARY':
         return notificationsSummaryData
      default:
         return state
   }
}
